import React from "react";

const CookiesSummarySnippet = () => (
  <p>
    Utilizamos cookies necessários e tecnologias semelhantes para que o UNBL
    funcione. Gostaríamos também de os utilizar para orientar as nossas
    melhorias, registando a forma como utiliza o site. Estes só serão ativados
    se aceitar.
  </p>
);

export default CookiesSummarySnippet;
